import { OpenExternalUrlAction } from "../../schema";

export function openExternalUrl(
  externalUrlAction: OpenExternalUrlAction,
  queryParamsData: Record<string, any>
) {
  let url = externalUrlAction.config.url;
  if (externalUrlAction.config.sendQueryParams) {
    url = `${url}?${new URLSearchParams(queryParamsData).toString()}`;
    window.open(url, "_blank");
  } else {
    window.open(url, "_blank");
  }
}
